import JSZip from 'jszip';

export const mimeType = 'text/plain';

function geometryToData(geometry, material, index, faceOffset, verticesOffset) {

  const faces = geometry.faces;
  const vertices = geometry.vertices;
  const faceVertexUvs = geometry.faceVertexUvs[0];

  var output = '';

  // Right, so first each mesh is seperated by a special name
  output += 'o block' + index + '\n';

  // Then, we draw the actual xyz positions of all the vertices that make up
  // the geometry
  for(var i = 0; i < vertices.length; i ++) {
    output += `v ${vertices[i].x} ${vertices[i].y} ${vertices[i].z}\n`;
  }

  // Next, we'll want to specify all the texture coordinates (uvs)
  for(let i = 0; i < faceVertexUvs.length; i ++) {

    const face = faceVertexUvs[i];
    for(let i = 0; i < face.length; i ++) {

      const uv = face[i];
      output += `vt ${uv.x} ${uv.y}\n`;
    }
  }

  // Then the face vertex normals
  for(let i = 0; i < faces.length; i ++) {

    const face = faces[i];
    for(let i = 0; i < face.vertexNormals.length; i ++) {

      const normal = face.vertexNormals[i];
      output += `vn ${normal.x} ${normal.y} ${normal.z}\n`;

    }
  }

  // Alright, onto materials
  var currentMaterial = null;
  for(let i = 0; i < faces.length; i ++) {

    // So, we're going to working with each face in the geometry here
    const face = faces[i];

    // Then we're going to define a material to use, if necessary
    if (material && face.materialIndex !== currentMaterial) {

      const mtl = material.isMultiMaterial ? material.materials[face.materialIndex] : material;

      output += `usemtl ${(mtl.name !== '') ? mtl.name : `material ${mtl.id}`}\n`;

      currentMaterial = face.materialIndex;
    }

    // And then on to the fun (hellish) part.
    const faceIndexes = [
      face.a + 1 + verticesOffset,
      face.b + 1 + verticesOffset,
      face.c + 1 + verticesOffset]
      .map(function(faceIndex, j) {
        return `${faceIndex}/${faceVertexUvs.length > 0 ? j + (index * 3): ''}/${(faceOffset) + i * 3 + j + 1}`
      })
      .join(' ');

    output += `f ${faceIndexes}\n`;

  }

  return output;

}

function materialToData(material) {

  var output = '';

  if (material.isMultiMaterial) {
    for(var mtl of material.materials) {
      output += materialToData(mtl);
    }
  } else {

    output += `newmtl ${(material.name !== '') ? material.name : `material ${material.id}`}\n`;

    output += 'Ns 10.0000\n';
    output += 'Ni 1.5000\n';
    output += 'd 1.0000\n';
    output += 'Tr 0.0000\n';
    output += 'Tf 1.0000 1.0000 1.0000\n';
    output += 'illum 2\n';
    output += `Ka ${material.color.r} ${material.color.g} ${material.color.b}\n`;
    output += `Kd ${material.color.r} ${material.color.g} ${material.color.b}\n`;
    output += 'Ks 0.0000 0.0000 0.0000\n';
    output += 'Ke 0.0000 0.0000 0.0000\n';

  }

  return output;

}
/**
 * The magic function. Give it an array of meshes, and it goes to work turning
 * those meshes into a single .obj file and a single .mtl file
 */
export function meshes(meshes) {

  // These two variables are strings.  Each pass of geometryToData and
  // materialToData takes on more data to these two
  var geometryData = 'mtllib material.mtl\n';
  var materialData = '';
  var faceOffset = 0;
  var verticesOffset = 0;
  meshes.forEach(function(mesh, index) {

    // Update the matrix real fast
    mesh.updateMatrix();

    // Next, create a clone of the geometry
    var geometry = mesh.geometry.clone();

    // You might need to apply the matrix to the geometry (fuck if I know why)
    geometry.applyMatrix(mesh.matrix);

    // Cool, now let's convert that geometry into some file data
    geometryData += geometryToData(geometry, mesh.material, index, faceOffset, verticesOffset);
    materialData += materialToData(mesh.material);
    faceOffset += geometry.faces.length * 3;
    verticesOffset += geometry.vertices.length;
  });

  // Finally, we generate some zips
  var zip = new JSZip();
  zip.file('object.obj', geometryData);
  zip.file('material.mtl', materialData);
  return zip.generateAsync({ type: 'blob' });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@glyphglyder/obj-exporter/index.js
// module id = 67
// module chunks = 0